<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-08-04 16:35:56
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2023-01-05 14:09:26
 * @FilePath: \music\src\components\home\footer.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="bothFooter">
        <div class="footer">
            <div class="footer_box">
                <div class="footer_item" v-for="(i, idx) in footerList" :key="idx">
                    <h3 v-if="idx != 'codes'">{{ i.name }}</h3>
                    <!-- 客户服务 -->
                    <template v-if="(idx == 'services')">
                        <div v-for="j in i.list" style="width: 200px;">
                            <p>{{ j.name }}</p>
                            <div class="contact">
                                <span>{{ j.contact }} </span>
                            </div>
                        </div>
                    </template>
                    <!-- //二维码 -->
                    <template v-if="(idx == 'codes')">
                        <div class="code">
                            <div v-for="j in i.list.slice(1)">
                                <h3>{{ j.name }}</h3>
                                <div class="contact">
                                    <img :src="($env.VUE_APP_URL + j.contact)" alt="">
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="(idx == 'links')">
                        <div style="width: 100px;">
                            <p v-for="j in i.list" @click="handLink(j.contact)">{{ j.name }}</p>
                        </div>
                    </template>
                    <template v-if="(idx == 'clauses')">
                        <div style="width: 100px;">
                            <p v-for="j in i.list" @click="handClick(j.article_id)">{{ j.title }}</p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="copyright">
            <footer>
                <a target="_blank" @click="qualification(1)">京网文[2021]3013-827号</a>
                <span style="margin:0 5px;">|</span>
                <a target="_blank" @click="qualification(2)">京B2-20182043</a>
                <span style="margin:0 10px;"></span>
                <a target="_blank"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011202000841">京公网安备
                    11011202000841号</a>
                <span style="margin:0 5px;">|</span>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备17046250</a>
                <span style="margin:0 5px;">|</span>
                <span>
                    © 2015-2023 Hikoon Copyright 版权所有
                </span>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            footerList: []
        }
    },
    mounted() {
        this.getFooterList()
    },
    methods: {
        qualification(id) {
            let routeData = this.$router.resolve({
                path: 'qualification',
                query: {
                    id
                }
            })
            window.open(routeData.href, '_blank');
        },
        handClick(id) {
            this.$router.push({
                path: '/caseDetail',
                query: {
                    id,
                    type: 2
                }
            })
        },
        async getFooterList() {
            this.footerList = await this.$home.services()
            if (this.footerList.codes.list.length) {
                this.$store.commit('SetService', this.footerList.codes.list[0].contact)
            }
        },
        handLink(val) {
            window.open(val)
        }
    }
}
</script>

<style lang="scss" scoped>
.contact {
    display: flex;
    align-items: center;

    img {
        width: 100px;
        height: 100px;
    }
}

.code {
    display: grid;
    width: 240px;
    // margin-top: 30px;
    grid-template-columns: repeat(2, 1fr);
    gap:20px 40px;
    h3{
        margin-bottom: 28px;
    }

    p {
        margin-bottom: 28px;
    }
}

.bothFooter {
    background-color: #C53931;
}

.footer {
    display: flex;
    width: 100%;
    margin-bottom: 85px;


    >div {
        width: 1200px;
        margin: 50px auto;
        margin-bottom: 0;
        display: flex;
        justify-content: space-between;
    }
    .footer_box {
        display: flex;
        justify-content: space-between;
        // grid-template-columns: repeat(4, 1fr);
    }
    .footer_item {
        flex-shrink: 0;

        h3 {
            font-size: 12px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFF7F7;
            cursor: pointer;
            line-height: 1;

        }

        p {
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFCCCC;
            margin-top: 20px;
            cursor: pointer;

            &:hover {
                color: #fff;
            }
        }

        span {
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFCCCC;
        }
    }
}

.copyright {
    width: 100%;
    // height: 58px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FAA0A0;
    text-align: center;

    footer {
        width: 1200px;
        margin: auto;
        border-top: 1px solid #D65151;
        padding: 22px 0;
    }


    a {
        color: #FAA0A0;
        text-decoration: none;
    }

    ul {
        display: flex;
        justify-content: center;
        gap: 5px;

        li {
            display: flex;
            align-items: center;
            gap: 5px;

            img {
                width: 20px;
                height: 20px;
            }


        }
    }
}
</style>